// Footer.js
import React from "react";
import "./Footer.css";

const Footer = () => (
    <footer>
      <a href="/impressum" className="nowrap">
        Impressum
      </a>
    </footer>
  );

export default Footer;
